module.exports = __webpack_public_path__ + "static/img/device_hy_s2.4e45a9a6.png";